import PropTypes from 'prop-types';
import React from 'react';
import {compose, getContext, shouldUpdate, withProps} from 'recompose';

import {JustRenderChildren, withContextFromProps} from 'iss/utils/context';
import {CollapsiblePanel} from 'iss/widgets/Panels';

const accordionContextTypes = {
  openedSection: PropTypes.number,
  onOpenSection: PropTypes.func.isRequired,
  sectionCount: PropTypes.number,
  sectionId: PropTypes.number,
};

export const Accordion = function({children, openedSection, onOpenSection}) {
  const sectionCount = React.Children.count(children);
  return React.Children.map(children, (child, index) => {
    return <AccordionSectionContext sectionId={index} sectionCount={sectionCount}
      onOpenSection={onOpenSection} openedSection={openedSection}>
      {child}
    </AccordionSectionContext>;
  });
};

const AccordionSectionContext = withContextFromProps(
  accordionContextTypes,
)(JustRenderChildren);

export const getAccordionContext = compose(
  getContext(accordionContextTypes),
  withProps(({openedSection, sectionId, onOpenSection, sectionCount}) => {
    const isOpened = sectionId === openedSection;
    const lastSection = sectionCount - 1;
    const isLastSection = sectionId === lastSection;
    return {
      isOpened, lastSection, isLastSection,
      toggleSection: () => onOpenSection(isOpened ? null : sectionId),
      openNextSection: () => onOpenSection(isLastSection ? null : sectionId + 1),
    };
  }),
  shouldUpdate((props, oldProps)=> props.isOpened || !!oldProps.isOpened || !!(props.shouldUpdate && props.shouldUpdate(props)))
);

export const AccordionSection = getAccordionContext(({children, sectionId, openedSection, onOpenSection, title, id}) => {
  const isOpened = sectionId === openedSection;
  const onTitleClick = () => isOpened ? onOpenSection(null) : onOpenSection(sectionId);

  return <CollapsiblePanel title={title} id={id} isOpened={isOpened} onTitleClick={onTitleClick}>
    {children}
  </CollapsiblePanel>;
});



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/Accordion.jsx